import { useQuery } from "@tanstack/react-query";
import { fetchAccountSettings } from "./httpAdmin";

// Frontend-spiegel van DishOnline-backend/config/plans.js.
// Houd de prijzen hier gelijk aan de backend.
export const PLANS = {
   basic: { id: "basic", name: "Basis", price: 19 },
   pro: { id: "pro", name: "Pro", price: 29 },
};

export const ADDONS = {
   giftCards: { id: "giftCards", name: "Cadeaubonnen", price: 5 },
};

// Gratis proefmaand, gelijk aan TRIAL_DAYS in DishOnline-backend/util/trial.js.
export const TRIAL_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

// Stand van de proefmaand voor de dagenteller. null = geen teller nodig (betaald, gratis
// toegang, of een backend die nog geen trialEndsAt meestuurt).
export function trialStatus(account, now = new Date()) {
   if (!account || account.hasSubscription || account.billingExempt || !account.trialEndsAt) return null;
   const endsAt = new Date(account.trialEndsAt);
   if (Number.isNaN(endsAt.getTime())) return null;
   const daysLeft = Math.max(0, Math.ceil((endsAt - now) / DAY_MS));
   return {
      endsAt,
      daysLeft,
      expired: Boolean(account.subscriptionRequired) || endsAt <= now,
      progress: Math.min(1, Math.max(0, 1 - (endsAt - now) / (TRIAL_DAYS * DAY_MS))),
   };
}

export const formatTrialEnd = (date) => date.toLocaleDateString("nl-BE", { day: "numeric", month: "long" });

// Leidt de beschikbare features af uit de accountgegevens.
// Valt terug op de backend-`features` indien aanwezig, anders zelf berekend.
export function deriveFeatures(account) {
   if (account?.features) {
      return {
         plan: account.plan || "basic",
         reservations: Boolean(account.features.reservations),
         giftCards: Boolean(account.features.giftCards),
      };
   }
   const plan = account?.plan || "basic";
   return {
      plan,
      reservations: plan === "pro",
      giftCards: Boolean(account?.addons?.giftCards),
   };
}

// Hook die de features van de ingelogde eigenaar teruggeeft.
// Hergebruikt dezelfde query-key als de accountinstellingen zodat er niet dubbel gefetcht wordt.
export function useFeatures() {
   const { data, isLoading, isError } = useQuery({
      queryKey: ["accountSettings"],
      queryFn: fetchAccountSettings,
   });

   return {
      account: data,
      features: deriveFeatures(data),
      isLoading,
      isError,
   };
}
